// extracted by mini-css-extract-plugin
export default {"info-overlay-content":"PUVy2x","infoOverlayContent":"PUVy2x"};